/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Create_ButtonInputs */



/**
* | output |
* | --- |
* | "Create" |
*
* @param {Options_Api_Keys_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_create_button = /** @type {((inputs?: Options_Api_Keys_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创造")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar")
	return /** @type {LocalizedString} */ ("Create")
});